<template>
  <p class="textGeneral" :class="{ isPc: !isSp }">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'TextGeneral',
  props: {
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.textGeneral {
  font-size: $text-size-paragraph2;
  line-height: $text-line-height-default;

  &.isPc {
    text-align: center;
  }
}
</style>
